import React from "react";
import "./header.css";

export default function Header() {
  return (
    <div className="header">
      <div className="headerTitles">
        <span className="headerTitleSm">
          Simplifying Research Process, we are Open Source Research Manager
        </span>
        <span className="headerTitleLg">OSR Manager</span>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <img
        className="headerImg"
        src="https://visme.co/blog/wp-content/uploads/2020/10/header-3-1.png"
        alt=""
      />
    </div>
  );
}
